import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';



const NEDLoadingTable = () => (
  <div className="loading-shading-mui">
    <CircularProgress className="loading-icon-mui" />
  </div>
);
export default NEDLoadingTable;